module.exports = __webpack_public_path__ + "static/media/about-us.c83dc045.jpg";